import React, { useState } from "react";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
} from "react-pro-sidebar";
import { NavLink } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import "./LeftMenu.css";

const LeftMenu = () => {
  
  const [menuCollapse, setMenuCollapse] = useState(true);

  const handleMouseEnter = () => {
    console.log("HI");
    setMenuCollapse(false);
  };

  const handleMouseExit = () => {
    setMenuCollapse(true);
  };

  return (
    <div id="header">
      <ProSidebar
        collapsed={menuCollapse}
        //   toggled={toggled}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseExit}
        breakPoint="md"
        style={{
          height: "100vh",
          transition: '0s'
          // box-shadow: 19px 10px 53px 7px rgba(27, 30, 123, 0.06)
        }}
      >
        <SidebarHeader >
          <div
            style={{
              //   padding: "24px",
              textTransform: "uppercase",
              fontWeight: "bold",
              fontSize: 14,
              letterSpacing: "1px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              border: "none",
              boxShadow: "19px 10px 53px 7px rgba(27, 30, 123, 0.06)",
            }}
          >
            {menuCollapse ? (
              <a
                className="sidebar-brand d-flex align-items-center justify-content-center"
                href="/"
                style={{ padding: "8px" }}
              >
                <div className="sidebar-brand-text mx-3">
                  <svg
                    width="63"
                    height="63"
                    viewBox="0 0 63 63"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_257_1537)">
                      <path d="M63 0H0V63H63V0Z" fill="#554DF1" />
                      <path
                        d="M31.5 56.1094C45.031 56.1094 56 45.0914 56 31.5C56 17.9086 45.031 6.89062 31.5 6.89062C17.969 6.89062 7 17.9086 7 31.5C7 45.0914 17.969 56.1094 31.5 56.1094Z"
                        fill="white"
                      />
                      <path
                        d="M48 31.9921C48 33.3657 47.5287 34.5292 46.5856 35.4833C45.6808 36.399 44.5491 36.8567 43.1915 36.8567C41.8713 36.8567 40.7211 36.399 39.7406 35.4833C38.7975 34.5292 38.3262 33.3657 38.3262 31.9921C38.3262 29.97 37.6096 28.234 36.1764 26.7841C34.7432 25.2961 33.0273 24.5521 31.0283 24.5521C28.9917 24.5521 27.2568 25.2961 25.8237 26.7841C24.3905 28.234 23.6739 29.97 23.6739 31.9921C23.6739 34.0144 24.3905 35.7693 25.8237 37.2573C27.2568 38.7072 28.9917 39.4321 31.0283 39.4321C32.3107 39.4321 33.4233 39.9091 34.3661 40.8629C35.3466 41.7786 35.837 42.9232 35.837 44.2969C35.837 45.6322 35.3657 46.7767 34.4226 47.7305C33.4798 48.6846 32.3484 49.1804 31.0283 49.2187C26.2385 49.1423 22.2407 47.4635 19.035 44.1823C15.8292 40.901 14.1509 36.8377 14 31.9921C14.1509 27.1466 15.8103 23.1023 18.9784 19.8592C22.1842 16.5779 26.182 14.8801 30.9717 14.7656C35.7993 14.8801 39.8159 16.597 43.0218 19.9164C46.2653 23.1976 47.9247 27.2229 48 31.9921ZM26.2197 31.9921C26.2197 30.6568 26.6722 29.5121 27.5774 28.5583C28.5203 27.5663 29.6706 27.0703 31.0283 27.0703C32.3484 27.0703 33.4798 27.5663 34.4226 28.5583C35.4034 29.5121 35.8934 30.6568 35.8934 31.9921C35.8934 33.3657 35.4034 34.5292 34.4226 35.4833C33.4798 36.399 32.3484 36.8567 31.0283 36.8567C29.6706 36.8567 28.5203 36.399 27.5774 35.4833C26.6722 34.5292 26.2197 33.3657 26.2197 31.9921Z"
                        fill="#554DF1"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_257_1537">
                        <rect width="63" height="63" rx="15" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </a>
            ) : (
              <a
                className="sidebar-brand d-flex align-items-center justify-content-center"
                href="/"
                style={{ padding: "24px", marginBottom: "1px" }}
              >
                <div className="sidebar-brand-text mx-3">
                  {" "}
                  <svg
                    width="170"
                    height="30"
                    viewBox="0 0 170 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_257_1536)">
                      <path
                        d="M-0.000277574 3.63485C-0.00562035 3.16122 0.0832423 2.69124 0.261145 2.25225C0.439047 1.81325 0.702439 1.414 1.03601 1.07771C1.36202 0.728058 1.75804 0.45102 2.19827 0.264643C2.6385 0.0782653 3.11306 -0.0132699 3.59103 -0.00399857H21.7639C22.2411 -0.0078557 22.714 0.0861411 23.1535 0.272188C23.5929 0.458235 23.9896 0.732382 24.319 1.07771C24.6644 1.40739 24.9387 1.8044 25.1247 2.24422C25.3108 2.68403 25.4047 3.15732 25.4007 3.63485C25.4105 4.11322 25.3193 4.58827 25.1329 5.02893C24.9464 5.46959 24.6691 5.86592 24.319 6.192C23.9831 6.52541 23.5842 6.78857 23.1455 6.96612C22.7068 7.14367 22.2371 7.23206 21.7639 7.22611H16.3099V17.2838C16.3173 18.7383 16.8984 20.1312 17.9269 21.1597C18.9555 22.1882 20.3483 22.7693 21.8029 22.7767C22.2696 22.7733 22.7323 22.8631 23.164 23.0406C23.5956 23.2182 23.9875 23.48 24.3168 23.8108C24.6667 24.1371 24.9439 24.5334 25.1303 24.974C25.3167 25.4147 25.4081 25.8896 25.3985 26.368C25.4046 26.8404 25.3138 27.3091 25.1319 27.7452C24.9499 28.1812 24.6806 28.5754 24.3406 28.9035C23.6743 29.5911 22.7624 29.9864 21.805 30.0025C18.2281 29.9462 15.2419 28.7088 12.8462 26.2901C10.4966 23.976 9.14614 20.8341 9.08401 17.5369V7.22611H3.59103C3.11732 7.23371 2.64691 7.14601 2.20776 6.96823C1.76861 6.79044 1.36967 6.52619 1.03466 6.19119C0.699653 5.85618 0.435402 5.45726 0.257613 5.01811C0.0798234 4.57897 -0.00787719 4.10856 -0.000277574 3.63485Z"
                        fill="#554DF1"
                      />
                      <path
                        d="M54.1706 17.2835C54.1791 17.7577 54.092 18.2288 53.9146 18.6687C53.7372 19.1086 53.4731 19.5084 53.138 19.8441C52.8029 20.1798 52.4037 20.4446 51.9641 20.6228C51.5245 20.801 51.0535 20.8889 50.5793 20.8812C50.1058 20.8875 49.6359 20.799 49.1971 20.6211C48.7583 20.4431 48.3596 20.1792 48.0243 19.845C47.6744 19.5191 47.3972 19.1231 47.2108 18.6829C47.0244 18.2426 46.933 17.768 46.9425 17.29C46.9507 16.5705 46.8126 15.8568 46.5367 15.1922C46.2607 14.5277 45.8527 13.9261 45.3373 13.424C44.8336 12.9092 44.2322 12.5001 43.5683 12.2209C42.9044 11.9416 42.1914 11.7978 41.4712 11.7978C40.751 11.7978 40.038 11.9416 39.3741 12.2209C38.7102 12.5001 38.1088 12.9092 37.6051 13.424C37.0963 13.931 36.6927 14.5336 36.4172 15.197C36.1418 15.8604 36 16.5717 36 17.29C36 18.0083 36.1418 18.7196 36.4172 19.383C36.6927 20.0464 37.0963 20.6489 37.6051 21.156C38.1069 21.6811 38.7119 22.0966 39.3821 22.3766C40.0523 22.6566 40.7731 22.7949 41.4993 22.7829C41.966 22.7797 42.4287 22.8696 42.8603 23.0471C43.2919 23.2247 43.6838 23.4864 44.0132 23.817C44.3628 24.1435 44.6398 24.5399 44.8262 24.9805C45.0125 25.421 45.1041 25.8959 45.095 26.3741C45.1013 26.8464 45.0109 27.315 44.8293 27.7511C44.6477 28.1871 44.3789 28.5814 44.0392 28.9096C43.3726 29.5969 42.4609 29.9921 41.5036 30.0087C37.9195 29.9481 34.9304 28.7084 32.5362 26.2898C30.142 23.8711 28.8886 20.8711 28.7761 17.29C28.8886 13.7117 30.1355 10.7183 32.5167 8.30966C34.8979 5.90106 37.8763 4.65494 41.4517 4.57129C45.0575 4.65638 48.0646 5.91693 50.4733 8.35293C52.8819 10.7889 54.1143 13.7658 54.1706 17.2835ZM37.9037 17.2835C37.8976 16.8099 37.9859 16.3399 38.1634 15.9009C38.341 15.4618 38.6042 15.0625 38.9378 14.7263C39.2641 14.3765 39.6605 14.0994 40.1011 13.913C40.5417 13.7266 41.0167 13.6352 41.495 13.6446C42.4555 13.6559 43.3734 14.0424 44.0526 14.7216C44.7318 15.4008 45.1183 16.3187 45.1296 17.2792C45.1388 17.7571 45.0473 18.2317 44.8609 18.6719C44.6745 19.1121 44.3975 19.5081 44.0478 19.8341C43.7135 20.1699 43.3155 20.4355 42.8771 20.6153C42.4387 20.7951 41.9688 20.8855 41.495 20.8812C41.0213 20.8888 40.5509 20.8011 40.1117 20.6233C39.6726 20.4456 39.2736 20.1813 38.9386 19.8463C38.6036 19.5113 38.3394 19.1124 38.1616 18.6732C37.9838 18.2341 37.8961 17.7637 37.9037 17.29V17.2835Z"
                        fill="#554DF1"
                      />
                      <path
                        d="M70.27 4.5647C73.8454 4.64979 76.8245 5.89591 79.2072 8.30307C81.5444 10.6129 82.886 13.7448 82.9456 17.0303V26.4086C82.9535 26.8825 82.866 27.3532 82.6883 27.7926C82.5107 28.232 82.2465 28.6311 81.9114 28.9664C81.5764 29.3016 81.1774 29.5661 80.7381 29.744C80.2988 29.9219 79.8282 30.0097 79.3543 30.0021C78.8806 30.0079 78.4104 29.9192 77.9714 29.7413C77.5323 29.5634 77.1331 29.2997 76.7971 28.9658C76.4473 28.6395 76.1701 28.2431 75.9838 27.8025C75.7974 27.3619 75.7059 26.8869 75.7154 26.4086V17.2834C75.7235 16.5639 75.5854 15.8502 75.3095 15.1856C75.0336 14.5211 74.6255 13.9195 74.1101 13.4174C73.6064 12.9026 73.005 12.4935 72.3411 12.2143C71.6772 11.935 70.9643 11.7912 70.244 11.7912C69.5238 11.7912 68.8108 11.935 68.147 12.2143C67.4831 12.4935 66.8816 12.9026 66.378 13.4174C65.8692 13.9245 65.4655 14.527 65.19 15.1904C64.9146 15.8538 64.7728 16.5651 64.7728 17.2834C64.7728 18.0017 64.9146 18.713 65.19 19.3764C65.4655 20.0398 65.8692 20.6423 66.378 21.1494C66.8798 21.6745 67.4848 22.09 68.1549 22.37C68.8251 22.65 69.546 22.7883 70.2722 22.7763C70.7389 22.7732 71.2015 22.863 71.6331 23.0405C72.0647 23.2181 72.4567 23.4798 72.7861 23.8104C73.1357 24.1369 73.4127 24.5333 73.599 24.9739C73.7854 25.4144 73.877 25.8893 73.8678 26.3675C73.8741 26.8398 73.7837 27.3084 73.6022 27.7445C73.4206 28.1805 73.1517 28.5748 72.812 28.903C72.1453 29.5901 71.2337 29.9853 70.2765 30.0021C66.6982 29.9458 63.7119 28.7062 61.3177 26.2832C58.9235 23.8601 57.6701 20.8602 57.5576 17.2834C57.6701 13.7051 58.9163 10.7117 61.296 8.30307C63.6758 5.89447 66.6671 4.64835 70.27 4.5647Z"
                        fill="#554DF1"
                      />
                      <path
                        d="M111.723 17.2834C111.666 20.8054 110.434 23.7844 108.025 26.2204C105.617 28.6564 102.609 29.917 99.0037 30.0021C95.4254 29.9184 92.4463 28.6716 90.0666 26.2615C87.6868 23.8515 86.4406 20.76 86.3281 16.987C86.3966 13.7061 87.7462 10.5823 90.0882 8.2836C92.481 5.86491 95.4672 4.62527 99.047 4.5647C99.5208 4.57236 99.9884 4.67338 100.423 4.86196C100.858 5.05054 101.251 5.32299 101.58 5.66371C101.92 5.99176 102.19 6.38595 102.372 6.82202C102.554 7.25808 102.644 7.72677 102.638 8.19923C102.648 8.67719 102.556 9.15174 102.37 9.59196C102.183 10.0322 101.906 10.4282 101.557 10.7542C101.228 11.0854 100.837 11.3479 100.406 11.5266C99.9755 11.7052 99.5134 11.7964 99.047 11.7948C98.3207 11.7822 97.5997 11.9203 96.9295 12.2003C96.2592 12.4803 95.6543 12.8962 95.1528 13.4217C94.6433 13.9283 94.2389 14.5307 93.9629 15.1942C93.687 15.8577 93.5449 16.5691 93.5449 17.2877C93.5449 18.0063 93.687 18.7177 93.9629 19.3812C94.2389 20.0447 94.6433 20.6471 95.1528 21.1537C95.6565 21.6685 96.2579 22.0776 96.9218 22.3568C97.5857 22.6361 98.2987 22.7799 99.0189 22.7799C99.7391 22.7799 100.452 22.6361 101.116 22.3568C101.78 22.0776 102.381 21.6685 102.885 21.1537C103.4 20.6516 103.808 20.05 104.084 19.3855C104.36 18.7209 104.498 18.0072 104.49 17.2877C104.481 16.8094 104.572 16.3345 104.759 15.8939C104.945 15.4533 105.222 15.0569 105.572 14.7306C105.908 14.397 106.307 14.1337 106.746 13.9562C107.186 13.7786 107.656 13.6903 108.129 13.6964C108.603 13.6888 109.073 13.7765 109.512 13.9543C109.952 14.1321 110.351 14.3964 110.686 14.7314C111.021 15.0664 111.285 15.4653 111.463 15.9045C111.64 16.3436 111.728 16.814 111.72 17.2877L111.723 17.2834Z"
                        fill="#554DF1"
                      />
                      <path
                        d="M118.695 1.1418e-05C119.173 -0.00384571 119.646 0.0901507 120.085 0.276198C120.524 0.462245 120.921 0.736393 121.251 1.08172C121.596 1.41164 121.87 1.80869 122.056 2.24845C122.242 2.68822 122.336 3.16139 122.332 3.63887V26.3676C122.342 26.846 122.25 27.3209 122.064 27.7615C121.877 28.2021 121.6 28.5985 121.251 28.9248C120.915 29.2598 120.517 29.5245 120.078 29.7036C119.639 29.8826 119.169 29.9724 118.695 29.9676C118.222 29.9755 117.751 29.888 117.312 29.7103C116.872 29.5327 116.473 29.2685 116.138 28.9334C115.802 28.5984 115.538 28.1994 115.36 27.7601C115.182 27.3208 115.094 26.8502 115.102 26.3763V3.63454C115.097 3.1609 115.186 2.69092 115.363 2.25193C115.541 1.81294 115.805 1.41369 116.138 1.07739C116.465 0.72836 116.862 0.45204 117.302 0.266415C117.743 0.08079 118.217 -0.00998047 118.695 1.1418e-05ZM127.736 11.7949C127.27 11.7979 126.807 11.7078 126.375 11.5298C125.944 11.3519 125.552 11.0897 125.223 10.7586C124.873 10.4326 124.596 10.0366 124.41 9.5964C124.223 9.15618 124.132 8.68162 124.141 8.20366C124.135 7.73136 124.225 7.26276 124.406 6.82671C124.588 6.39066 124.857 5.99638 125.197 5.66815C125.526 5.32736 125.92 5.05489 126.355 4.86631C126.79 4.67774 127.258 4.57675 127.732 4.56913C131.31 4.62538 134.297 5.86502 136.691 8.28803C139.036 10.6006 140.384 13.7377 140.449 17.0304V26.4088C140.457 26.8826 140.369 27.3533 140.192 27.7927C140.014 28.2321 139.75 28.6313 139.415 28.9665C139.08 29.3017 138.681 29.5662 138.241 29.7441C137.802 29.922 137.331 30.0098 136.858 30.0022C136.384 30.008 135.914 29.9194 135.475 29.7414C135.036 29.5635 134.636 29.2999 134.3 28.9659C133.951 28.6396 133.673 28.2432 133.487 27.8026C133.301 27.362 133.209 26.8871 133.219 26.4088V17.2835C133.211 15.8312 132.632 14.4405 131.605 13.4129C130.579 12.3854 129.189 11.804 127.736 11.7949Z"
                        fill="#554DF1"
                      />
                      <path
                        d="M169.222 17.2835C169.229 17.757 169.141 18.2272 168.963 18.666C168.785 19.1049 168.521 19.5036 168.186 19.8385C167.851 20.1734 167.452 20.4376 167.013 20.6156C166.574 20.7936 166.104 20.8817 165.631 20.8747C165.157 20.8811 164.687 20.7926 164.248 20.6147C163.808 20.4367 163.409 20.1728 163.074 19.8385C162.724 19.5125 162.447 19.1164 162.261 18.6762C162.074 18.236 161.983 17.7614 161.992 17.2835C162 16.564 161.862 15.8503 161.586 15.1857C161.31 14.5212 160.902 13.9196 160.387 13.4175C159.883 12.9027 159.281 12.4936 158.618 12.2144C157.954 11.9351 157.241 11.7913 156.521 11.7913C155.8 11.7913 155.087 11.9351 154.423 12.2144C153.76 12.4936 153.158 12.9027 152.654 13.4175C152.145 13.9241 151.741 14.5265 151.465 15.19C151.189 15.8534 151.047 16.5649 151.047 17.2835C151.047 18.002 151.189 18.7135 151.465 19.377C151.741 20.0405 152.145 20.6428 152.654 21.1495C153.156 21.675 153.761 22.0908 154.431 22.3709C155.101 22.6509 155.822 22.7889 156.549 22.7764C157.015 22.7733 157.478 22.8631 157.91 23.0406C158.341 23.2182 158.733 23.4799 159.063 23.8105C159.412 24.137 159.689 24.5334 159.876 24.974C160.062 25.4145 160.153 25.8894 160.144 26.3676C160.15 26.8401 160.06 27.3088 159.878 27.7448C159.696 28.1809 159.426 28.5751 159.086 28.9032C158.421 29.5905 157.51 29.9857 156.553 30.0022C152.976 29.9459 149.988 28.7084 147.588 26.2898C145.188 23.8711 143.934 20.8711 143.828 17.29C143.937 13.7117 145.183 10.7183 147.566 8.30966C149.949 5.90106 152.928 4.65494 156.503 4.57129C160.109 4.65638 163.116 5.91693 165.525 8.35293C167.933 10.7889 169.166 13.7658 169.222 17.2835ZM152.953 17.2835C152.947 16.8098 153.036 16.3397 153.214 15.9006C153.392 15.4615 153.655 15.0623 153.989 14.7263C154.316 14.3765 154.712 14.0994 155.153 13.913C155.593 13.7266 156.068 13.6352 156.546 13.6446C157.507 13.6564 158.424 14.0432 159.103 14.7223C159.781 15.4015 160.168 16.3191 160.179 17.2792C160.188 17.7571 160.097 18.2317 159.91 18.6719C159.724 19.1121 159.447 19.5081 159.097 19.8341C158.764 20.1686 158.368 20.4335 157.931 20.6132C157.495 20.793 157.027 20.8841 156.555 20.8812C156.081 20.8885 155.611 20.8006 155.172 20.6228C154.733 20.4449 154.334 20.1807 153.999 19.8458C153.664 19.5108 153.399 19.1121 153.221 18.673C153.043 18.234 152.955 17.7637 152.962 17.29L152.953 17.2835Z"
                        fill="#554DF1"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_257_1536">
                        <rect width="169.231" height="30" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </a>
            )}
          </div>
        </SidebarHeader>

        <SidebarContent style={{background: 'white'}}>
          <Menu iconShape="round">
            <MenuItem>
              <NavLink
                className="nav-link"
                activeClassName="activeLink1"
                to={`/users`}
                style={{ padding: "0px" }}
              >
                <img
                  alt="User Active"
                  className="users_active"
                  src="/icons/users_active.svg"
                  style={{
                    padding: "0px",
                    width: "35px",
                    height: "35px",
                    marginRight: "20px",
                  }}
                />
                <img
                  alt="user"
                  className="users"
                  src="/icons/users.svg"
                  style={{
                    padding: "0px",
                    width: "35px",
                    height: "35px",
                    marginRight: "20px",
                  }}
                />
                <span className="side-menu-text">Users</span>
              </NavLink>
            </MenuItem>
          </Menu>
          <Menu iconShape="round">
            <MenuItem>
              <NavLink
                className="nav-link"
                activeClassName="activeLink1"
                to={`/instructor`}
                style={{ padding: "0px" }}
              >
                <img
                alt="Instructor Active"
                  className="users_active"
                  src="/icons/instructor_active.svg"
                  style={{
                    padding: "0px",
                    width: "35px",
                    height: "35px",
                    marginRight: "20px",
                  }}
                />
                <img
                alt="Instructor"
                  className="users"
                  src="/icons/instructor.svg"
                  style={{
                    padding: "0px",
                    width: "35px",
                    height: "35px",
                    marginRight: "20px",
                  }}
                />
                <span className="side-menu-text">Instructors</span>
              </NavLink>
            </MenuItem>
          </Menu>
          <Menu iconShape="round">
            <MenuItem>
              <NavLink
                className="nav-link"
                activeClassName="activeLink1"
                to={`/classes`}
                style={{ padding: "0px" }}
              >
                <img
                  alt="Class Acitve"
                  className="users_active"
                  src="/icons/class_active.svg"
                  style={{
                    padding: "0px",
                    width: "35px",
                    height: "35px",
                    marginRight: "20px",
                  }}
                />
                <img
                  alt="Class"
                  className="users"
                  src="/icons/class.svg"
                  style={{
                    padding: "0px",
                    width: "35px",
                    height: "35px",
                    marginRight: "20px",
                  }}
                />
                <span className="side-menu-text">Classes</span>
              </NavLink>
            </MenuItem>
          </Menu>
          <Menu iconShape="round">
            <MenuItem>
              <NavLink
                className="nav-link"
                activeClassName="activeLink1"
                to={`/issues`}
                style={{ padding: "0px" }}
              >
                <img
                alt="Issue Active"
                  className="users_active"
                  src="/icons/issue_active.svg"
                  style={{
                    padding: "0px",
                    width: "35px",
                    height: "35px",
                    marginRight: "20px",
                  }}
                />
                <img
                alt="Issue"
                  className="users"
                  src="/icons/issue.svg"
                  style={{
                    padding: "0px",
                    width: "35px",
                    height: "35px",
                    marginRight: "20px",
                  }}
                />
                <span className="side-menu-text">Issues</span>
              </NavLink>
            </MenuItem>
          </Menu>
        </SidebarContent>

        <SidebarFooter>  
          <Menu iconShape="round">
            <MenuItem>
              <NavLink
                className="nav-link"
                activeClassName="activeLink1"
                to={`/logout`}
                style={{ padding: "0px" }}
              >
                <img
                alt="Logout"
                  className="users_active"
                  src="/icons/logout_active.svg"
                  style={{
                    padding: "0px",
                    width: "35px",
                    height: "35px",
                    marginRight: "20px",
                  }}
                />
                <img
                alt="logout"
                  className="users"
                  src="/icons/logout.svg"
                  style={{
                    padding: "0px",
                    width: "35px",
                    height: "35px",
                    marginRight: "20px",
                  }}
                />
                <span className="side-menu-text">Log out</span>
              </NavLink>
            </MenuItem>
          </Menu>
        </SidebarFooter>
      </ProSidebar>
    </div>
  );
};

export default LeftMenu;
